import React from 'react';
import { Modal, Table } from 'antd';
import RichText from '../../components/RichEditor/RichText';
import { format, parseISO } from "date-fns";
import { HH_mm_dd_MM_yyyy } from '../../constants';
import { CustomHistoryTable } from './WorkSchedulePersonalStyle';
import TableComponent from '../../components/Common/TableComponent';

const WorkSchedulePersonalHistory = props => {
    const dataSource = [];
    let colorIndex = 1;
    Object.keys(props.historyList).forEach(date => {
        const records = props.historyList[date];
        records.forEach((record, index) => {
            dataSource.push({
                ...record,
                key: `${date}-${index}`,
                groupIndex: colorIndex,
                rowSpan: index === 0 ? records.length : 0
            });
        });
        colorIndex++;
    });
    console.log(dataSource)
    const formatDate = (dateString) => {
        const date = parseISO(dateString);
        return format(date, HH_mm_dd_MM_yyyy);
    };

    const columns = [
        {
            title: 'Ngày',
            width: 150,
            dataIndex: 'field',
            render: (text, record) => ({
                children: <RichText htmlText={text} />,
                props: {
                    rowSpan: record.rowSpan,
                }
            })
        },
        {
            title: 'Trước thay đổi',
            width: 300,
            dataIndex: 'fieldValueBefore',
            render: text => (
                <div style={{ maxWidth: '300px', whiteSpace: 'pre-wrap', textAlign: 'justify' }}>
                    <RichText htmlText={text} />
                </div>
            )
        },
        {
            title: 'Sau thay đổi',
            width: 300,
            dataIndex: 'fieldValueAfter',
            render: text => (
                <div style={{ maxWidth: '300px', whiteSpace: 'pre-wrap', textAlign: 'justify' }}>
                    <RichText htmlText={text} />
                </div>
            )
        },
        {
            title: 'Thời gian cập nhật',
            width: 200,
            dataIndex: 'lastModifiedDate',
            render: text => <span>{formatDate(text)}</span>
        },
        {
            title: 'Người thay đổi',
            width: 150,
            dataIndex: 'lastModifiedBy',
            render: text => <span style={{ textTransform: 'capitalize' }}>{text}</span>
        }
    ];

    return (
        <Modal
            title={'Lịch sử'}
            width={1300}
            style={{ top: 40 }}
            open={props.open}
            closable={true}
            maskClosable={true}
            onCancel={props.onCancel}
            footer={null}
        >
            <CustomHistoryTable>
                <TableComponent
                    dataSource={dataSource}
                    columns={columns}
                    pagination={false}
                    bordered
                    rowClassName={(_, index) =>
                        dataSource[index].groupIndex % 2 === 0 ? "even-group" : "odd-group"
                    }
                    loading={props.isLoadingHistory}
                />
            </CustomHistoryTable>

        </Modal>
    )
}

export default WorkSchedulePersonalHistory;
